module.exports = "/fonts/Flaticon2.eot?29586ff0f963f4d1fdfc182822b8b27a";